import { render, staticRenderFns } from "./PaddyFieldShow.vue?vue&type=template&id=b35c44e2&"
import script from "./PaddyFieldShow.vue?vue&type=script&lang=js&"
export * from "./PaddyFieldShow.vue?vue&type=script&lang=js&"
import style0 from "./PaddyFieldShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports